import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import {
  GetTutorialVideosResponse,
  TutorialVideo
} from './getTutorialVideos.types'

const getTutorialVideos = async (appId: string) => {
  const response = await containerApi.get<GetTutorialVideosResponse>(
    '/tutorial-videos',
    { params: { app_id: appId } }
  )
  return response.data.data
}

const GET_TUTORIAL_VIDEOS_QUERY_KEY = 'getTutorialVideos'

export const useGetTutorialVideosQuery = (
  appId: string | undefined,
  options?: ExtendableQueryOptions<TutorialVideo[]>
) => {
  return useQuery({
    queryKey: [GET_TUTORIAL_VIDEOS_QUERY_KEY, appId],
    queryFn: () => getTutorialVideos(appId!),
    enabled: !!appId,
    staleTime: 60_000,
    ...options
  })
}
